// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/styles"], () => (__webpack_require__("./source/assets/js/main.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/styles"], () => (__webpack_require__("./source/assets/scss/styles.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
